import React from 'react';

interface WelcomeScreenProps {
  onNext: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onNext }) => {
  return (
    <div className="relative flex flex-col items-center justify-between h-[100dvh] bg-gray-900 text-white overflow-hidden">
      {/* Background image and overlays occupy the whole screen */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&q=80&w=1000"
          alt="Background Pizza"
          className="w-full h-full object-cover opacity-90"
        />
      </div>

      <div className="absolute inset-0 z-10 bg-green-900/60 mix-blend-overlay backdrop-blur-[1px]"></div>
      <div className="absolute inset-0 z-10 bg-black/20"></div>

      {/* Paddings moved into a layout wrapper */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-between w-full h-full p-8 md:p-12">
        <div className="flex-1 flex flex-col items-center justify-center text-center mt-10">
          <div 
            className="h-24 md:h-32 mb-8 animate-fade-in-down drop-shadow-2xl cursor-pointer"
            onPointerDown={(e) => {
              const timer = setTimeout(() => {
                const pass = prompt("Accès Admin - Mot de passe secret:");
                if (pass === "yumii2024") { // Temporary secret
                  localStorage.setItem('yumii_admin_mode', 'true');
                  onNext();
                }
              }, 3000);
              (e.target as any)._adminTimer = timer;
            }}
            onPointerUp={(e) => {
              clearTimeout((e.target as any)._adminTimer);
            }}
          >
            <img src="/logo.svg" alt="Yumii Logo" className="h-full w-auto object-contain" />
          </div>

          <h2 className="text-3xl font-bold mb-4 animate-fade-in-up drop-shadow-lg text-white">Bienvenue chez vous.</h2>
          <p className="text-white/90 text-lg max-w-xs leading-relaxed animate-fade-in-up delay-100 drop-shadow-md font-medium">
            Vous êtes sur la meilleure application pour découvrir des restaurants uniques et commander vos plats préférés.
          </p>
        </div>

        <div className="w-full max-w-sm pb-8 animate-fade-in-up delay-200">
          <button
            onClick={onNext}
            className="w-full py-4 bg-white text-green-800 text-xl font-bold rounded-full shadow-2xl hover:bg-gray-100 hover:scale-[1.02] transform transition-all active:scale-95 flex items-center justify-center group"
          >
            Commencer l'aventure
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>

        <div className="pb-2 opacity-30">
          <p className="text-[10px] text-white font-mono">v1.4.4</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;